export default function ProjectTileSection({ children }) {
  return <section className="flex flex-wrap justify-start mt-6 sm:text-lg text-base">{children}</section>;
}
